










exports.default =
  props: ['voipCalls']

  components:
    listItem: require('./list_item')

  methods:
    nextPage: ->
      @$emit 'next-page'



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/voip_report/list.vue